import { AppShell } from "./components/AppShell";
import type { PlatformRouteConfig } from "./types/platformRoutes";

import DashboardMobile from "./pages/Dashboard.mobile";
import SettingsMobile from "./pages/Settings.mobile";
import ProfileMobile from "./pages/Profile.mobile";
import InvestableAssetsMobile from "./pages/InvestableAssets.mobile";
import RealEstateAssetsMobile from "./pages/RealEstateAssets.mobile";
import LiabilitiesMobile from "./pages/Liabilities.mobile";
import IncomeMobile from "./pages/Income.mobile";
import ExpensesMobile from "./pages/Expenses.mobile";
import AssumptionsMobile from "./pages/Assumptions.mobile";
import OnboardingPageMobile from "./pages/OnboardingPage.mobile";

const mobileRoutes: PlatformRouteConfig = {
  Dashboard: DashboardMobile,
  Settings: SettingsMobile,
  Profile: ProfileMobile,
  InvestableAssets: InvestableAssetsMobile,
  RealEstateAssets: RealEstateAssetsMobile,
  Liabilities: LiabilitiesMobile,
  Income: IncomeMobile,
  Expenses: ExpensesMobile,
  Assumptions: AssumptionsMobile,
  OnboardingPage: OnboardingPageMobile,
};

/**
 * MobileApp - Mobile platform application (< 768px)
 *
 * Mobile-specific routing with full-screen settings pages.
 * Settings are accessed via navigation, not modals.
 */
function MobileApp() {
  return <AppShell routes={mobileRoutes} />;
}

export default MobileApp;
